'use strict';

exports.__esModule = true;
exports.app = undefined;

var _vue = require('vue');

var _mitt = require('mitt');

var _mitt2 = _interopRequireDefault(_mitt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable eol-last */
var emitter = (0, _mitt2.default)();

// adding support for once
emitter.once = function (type, handler) {
  var fn = function fn() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    emitter.off(type, fn);
    handler(args);
  };
  emitter.on(type, fn);
};
var app = exports.app = (0, _vue.createApp)();

app.config.globalProperties.$isServer = typeof window === 'undefined';
app.config.globalProperties.emitter = emitter;
// app.mount('#app');